/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const appBar = {
  defaultProps: {
    color: "inherit", // modern & adaptive
    elevation: 1,
  },

  styleOverrides: {
    root: {
      backgroundColor: "#FFFFFF",
      color: "#111827",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
      minHeight: "64px",
      padding: "0 1rem",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      zIndex: 1200,
    },
  },
};

export default appBar;
